'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactRouter = require('react-router');

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MenuItem: {
        displayName: 'MenuItem'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Menu/default/MenuBody/MenuItem.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MenuItem = _wrapComponent('MenuItem')(function (_Component) {
    (0, _inherits3.default)(MenuItem, _Component);

    function MenuItem(props) {
        (0, _classCallCheck3.default)(this, MenuItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call(this, props));

        _this.handleClick = function (category) {
            return function (e) {
                e.preventDefault();
                _this.props.onClick_Category(category);
            };
        };

        _this.handleClickDescription = function (category) {
            return function (e) {
                e.preventDefault();
                _this.toggleDescription();
            };
        };

        _this.state = {
            showDescription: false
        };
        return _this;
    }

    (0, _createClass3.default)(MenuItem, [{
        key: 'toggleDescription',
        value: function toggleDescription() {
            this.setState(function (prevState) {
                return { showDescription: !prevState.showDescription };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var encapsulatePadding = 10;
            var _props = this.props,
                encapsulate = _props.encapsulate,
                category = _props.category;

            var firstChild = '';
            if (encapsulate === 0) {
                firstChild = "first_category";
            }
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'li',
                    { className: 'red_style', style: { position: 'relative' } },
                    _react3.default.createElement(
                        'a',
                        { className: "drop_menu_item link_underline " + firstChild, style: { paddingLeft: 0 + encapsulate },
                            href: '#',
                            onClick: this.handleClick(category)
                        },
                        _react3.default.createElement(
                            'div',
                            { style: { display: 'flex' } },
                            _react3.default.createElement(
                                'div',
                                { style: { width: '90%' } },
                                category.title
                            )
                        )
                    ),
                    category.picture_menu ? _react3.default.createElement('img', { src: category.picture_menu, alt: '', style: { width: '60%' } }) : null,
                    this.state.showDescription ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: category.description_menu } }) : null,
                    category.children && category.children.length > 0 ? _react3.default.createElement(
                        'ul',
                        null,
                        category.children.map(function (item, index) {
                            return _react3.default.createElement(MenuItem, {
                                key: index,
                                category: item,
                                encapsulate: encapsulate + encapsulatePadding,
                                onClick_Category: _this2.props.onClick_Category,
                                openMenu: _this2.props.openMenu,
                                closeMenu: _this2.props.closeMenu,
                                toggleMenu: _this2.props.toggleMenu
                            });
                        })
                    ) : null,
                    category.description_menu ? _react3.default.createElement(
                        'div',
                        { style: { height: '21px',
                                width: '10%',
                                display: 'inline-block', padding: '.3em .6em .4em',
                                fontSize: '85%', fontWeight: 'bold', lineHeight: 1, color: '#fff',
                                textAlign: 'center',
                                verticalAlign: 'top',
                                borderRadius: '.20em',
                                backgroundColor: '#5bc0de',
                                position: 'absolute',
                                top: '14px',
                                left: '90%'
                            },
                            onClick: this.handleClickDescription(category)
                        },
                        _react3.default.createElement(
                            'i',
                            null,
                            'i'
                        )
                    ) : null
                )
            );
        }
    }]);
    return MenuItem;
}(_react2.Component));

exports.default = MenuItem;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/default/MenuBody/MenuItem.jsx
// module id = 751
// module chunks = 0